export class Format {

  static round(value?: number): number | undefined {
    if (!value) {
      return undefined
    }

    return Math.round(value)
  }
}
